import React, { useState, useCallback, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaTimes, FaChevronLeft, FaChevronRight, FaExpand, FaFacebookF, FaInstagram } from 'react-icons/fa';
import '../ConstructionGallery/ConstructionGallery.css';
import './SoftwareGallery.css';

const galleryItems = [
  // 1st: q set
  { id: 1,  src: '/images/softwware/q1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 2,  src: '/images/softwware/q2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 3,  src: '/images/softwware/q3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 4,  src: '/images/softwware/q4.jpeg',  title: 'Software Project', category: 'web' },
  { id: 5,  src: '/images/softwware/q5.jpeg',  title: 'Software Project', category: 'web' },
  { id: 6,  src: '/images/softwware/q6.jpeg',  title: 'Software Project', category: 'web' },
  { id: 7,  src: '/images/softwware/q7.jpeg',  title: 'Software Project', category: 'web' },
  { id: 8,  src: '/images/softwware/q8.jpeg',  title: 'Software Project', category: 'web' },
  { id: 9,  src: '/images/softwware/q9.jpeg',  title: 'Software Project', category: 'web' },
  { id: 10, src: '/images/softwware/q10.jpeg', title: 'Software Project', category: 'web' },
  { id: 11, src: '/images/softwware/q11.jpeg', title: 'Software Project', category: 'web' },
  { id: 12, src: '/images/softwware/q12.jpeg', title: 'Software Project', category: 'web' },
  { id: 13, src: '/images/softwware/q13.jpeg', title: 'Software Project', category: 'web' },
  // 2nd: a set
  { id: 13, src: '/images/softwware/a1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 14, src: '/images/softwware/a2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 15, src: '/images/softwware/a3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 16, src: '/images/softwware/a4.jpeg',  title: 'Software Project', category: 'web' },
  { id: 17, src: '/images/softwware/a5.jpeg',  title: 'Software Project', category: 'web' },
  { id: 18, src: '/images/softwware/a6.jpeg',  title: 'Software Project', category: 'web' },
  { id: 19, src: '/images/softwware/a7.jpeg',  title: 'Software Project', category: 'web' },
  { id: 20, src: '/images/softwware/a8.jpeg',  title: 'Software Project', category: 'web' },
  { id: 21, src: '/images/softwware/a10.jpeg', title: 'Software Project', category: 'web' },
  // 3rd: x set
  { id: 22, src: '/images/softwware/x1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 23, src: '/images/softwware/x2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 24, src: '/images/softwware/x3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 25, src: '/images/softwware/x4.jpeg',  title: 'Software Project', category: 'web' },
  { id: 26, src: '/images/softwware/x5.jpeg',  title: 'Software Project', category: 'web' },
  { id: 27, src: '/images/softwware/x6.jpeg',  title: 'Software Project', category: 'web' },
  // 4th: WhatsApp set
  { id: 28, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.02%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 30, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.02%20PM%20%281%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 31, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.02%20PM%20%282%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 32, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.03%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 33, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.03%20PM%20%281%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 34, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.06%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 35, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.07%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 36, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.07%20PM%20%281%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 37, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.08%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 38, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.08%20PM%20%281%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 39, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.08%20PM%20%282%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 40, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.09%20PM.jpeg',           title: 'Software Project', category: 'web' },
  { id: 41, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.09%20PM%20%281%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 42, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%202.00.09%20PM%20%282%29.jpeg', title: 'Software Project', category: 'web' },
  { id: 43, src: '/images/softwware/WhatsApp%20Image%202026-04-13%20at%203.25.38%20PM%20%283%29.jpeg', title: 'Software Project', category: 'web' },
  // remaining sets
  { id: 46, src: '/images/softwware/e1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 47, src: '/images/softwware/e2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 48, src: '/images/softwware/e3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 49, src: '/images/softwware/e4.jpeg',  title: 'Software Project', category: 'web' },
  { id: 50, src: '/images/softwware/e5.jpeg',  title: 'Software Project', category: 'web' },
  { id: 51, src: '/images/softwware/e6.jpeg',  title: 'Software Project', category: 'web' },
  { id: 52, src: '/images/softwware/e7.jpeg',  title: 'Software Project', category: 'web' },
  { id: 53, src: '/images/softwware/e8.jpeg',  title: 'Software Project', category: 'web' },
  { id: 54, src: '/images/softwware/e9.jpeg',  title: 'Software Project', category: 'web' },
  { id: 55, src: '/images/softwware/r1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 56, src: '/images/softwware/r2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 57, src: '/images/softwware/r3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 58, src: '/images/softwware/s1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 59, src: '/images/softwware/s2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 60, src: '/images/softwware/w1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 61, src: '/images/softwware/w2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 62, src: '/images/softwware/w3.jpeg',  title: 'Software Project', category: 'web' },
  { id: 63, src: '/images/softwware/w4.jpeg',  title: 'Software Project', category: 'web' },
  { id: 64, src: '/images/softwware/w5.jpeg',  title: 'Software Project', category: 'web' },
  { id: 65, src: '/images/softwware/w6.jpeg',  title: 'Software Project', category: 'web' },
  { id: 66, src: '/images/softwware/w7.jpeg',  title: 'Software Project', category: 'web' },
  { id: 67, src: '/images/softwware/w8.jpeg',  title: 'Software Project', category: 'web' },
  { id: 68, src: '/images/softwware/w9.jpeg',  title: 'Software Project', category: 'web' },
  { id: 69, src: '/images/softwware/z1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 70, src: '/images/softwware/z2.jpeg',  title: 'Software Project', category: 'web' },
  { id: 71, src: '/images/softwware/c1.jpeg',  title: 'Software Project', category: 'web' },
  { id: 72, src: '/images/softwware/c2.jpeg',  title: 'Software Project', category: 'web' },
];

const SoftwareGallery = () => {
  const [ref, inView] = useInView({ threshold: 0.05, triggerOnce: true });
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });
  const [visibleCount, setVisibleCount] = useState(12);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const filtered = galleryItems;
  const visibleItems = filtered.slice(0, visibleCount);

  const openLightbox = useCallback((index) => {
    setLightbox({ open: true, index });
    document.body.style.overflow = 'hidden';
  }, []);

  const closeLightbox = useCallback(() => {
    setLightbox({ open: false, index: 0 });
    document.body.style.overflow = '';
  }, []);

  const navigateLightbox = useCallback((direction) => {
    setLightbox((prev) => {
      const newIndex = direction === 'next'
        ? (prev.index + 1) % filtered.length
        : (prev.index - 1 + filtered.length) % filtered.length;
      return { ...prev, index: newIndex };
    });
  }, [filtered.length]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') navigateLightbox('next');
    if (e.key === 'ArrowLeft') navigateLightbox('prev');
  }, [closeLightbox, navigateLightbox]);

  const handleTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchEnd = useCallback((e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = Math.abs(e.changedTouches[0].clientY - touchStartY.current);
    if (Math.abs(dx) > 50 && dy < 80) {
      if (dx < 0) navigateLightbox('next');
      else navigateLightbox('prev');
    }
    touchStartX.current = null;
    touchStartY.current = null;
  }, [navigateLightbox]);

  React.useEffect(() => {
    if (lightbox.open) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [lightbox.open, handleKeyDown]);

  return (
    <section className="gallery sw-gallery" id="sw-gallery" ref={ref}>
      <div className="gallery__bg-text">WORK</div>
      <div className="gallery__container">
        <motion.div
          className="gallery__header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className="section-tag">Recent Projects</span>
          <h2 className="section-title">
            Projects We've
            <br />
            <span className="text-green">Done Recently</span>
          </h2>
          <p className="section-description">
            A few of the mobile apps, web platforms, and POS systems we've built and delivered
            to real businesses across Sri Lanka.
          </p>
        </motion.div>

        <motion.div className="gallery__masonry" layout>
          <AnimatePresence mode="popLayout">
            {visibleItems.map((item, i) => (
              <motion.div
                key={item.id}
                className="gallery__item gallery__item--medium"
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                onClick={() => openLightbox(i)}
              >
                <div className="gallery__item-img-wrap">
                  <div className="sw-phone-frame">
                    <div className="sw-phone-notch" />
                    <img src={item.src} alt={item.title} loading="lazy" />
                  </div>
                  <div className="gallery__item-overlay">
                    <div className="gallery__item-expand">
                      <FaExpand />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {visibleCount < filtered.length && (
          <motion.div
            className="gallery__load-more"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ delay: 0.5 }}
          >
            <button
              className="gallery__load-btn"
              onClick={() => setVisibleCount(galleryItems.length)}
            >
              Load More Projects
            </button>
          </motion.div>
        )}

        <motion.div
          className="gallery__follow"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <span className="gallery__follow-label">Follow Our Work</span>
          <div className="gallery__follow-links">
            <a
              href="https://www.facebook.com/profile.php?id=61573995033166"
              target="_blank"
              rel="noopener noreferrer"
              className="gallery__follow-btn gallery__follow-btn--fb"
            >
              <FaFacebookF />
              KAT99 Pvt Ltd
            </a>
            <a
              href="https://instagram.com/kat99_pvt_ltd"
              target="_blank"
              rel="noopener noreferrer"
              className="gallery__follow-btn gallery__follow-btn--ig"
            >
              <FaInstagram />
              @kat99_pvt_ltd
            </a>
          </div>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox.open && filtered[lightbox.index] && (
          <motion.div
            className="gallery__lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={closeLightbox}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <button className="gallery__lightbox-close" onClick={closeLightbox}>
              <FaTimes />
            </button>
            <div className="gallery__lightbox-counter-top">
              {lightbox.index + 1} / {filtered.length}
            </div>
            <motion.div
              className="gallery__lightbox-content"
              key={lightbox.index}
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -40 }}
              transition={{ duration: 0.22 }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={filtered[lightbox.index].src}
                alt={filtered[lightbox.index].title}
              />
            </motion.div>
            <div className="gallery__lightbox-bar" onClick={(e) => e.stopPropagation()}>
              <button
                className="gallery__lightbox-nav"
                onClick={() => navigateLightbox('prev')}
              >
                <FaChevronLeft />
              </button>
              <div className="gallery__lightbox-info">
                <h3>{filtered[lightbox.index].title}</h3>
              </div>
              <button
                className="gallery__lightbox-nav"
                onClick={() => navigateLightbox('next')}
              >
                <FaChevronRight />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default SoftwareGallery;
